<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle" :type="'home'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section>
          <div class="guideMsg ac">
            <p class="txtL">
              회원님의 정보를 안전하게 보호하기 위해
              <br />
              간편 휴대폰 문자인증을 진행해주세요.
            </p>
          </div>
          <div class="formArea">
            <div class="iptWrap">
              <span class="label">
                휴대폰번호
              </span>
              <div class="setPhone">
                <input
                  type="tel"
                  id="phone_2"
                  class="ipt"
                  autocomplete="off"
                  title="휴대폰 번호 입력"
                  placeholder="' - ' 없이 입력해주세요."
                  value=""
                  v-model="cellNum"
                  disabled
                />
                <button type="button" class="btn_s round s" @click="sendAuthNumber">
                  {{ authButtonTitle }}
                </button>
              </div>
            </div>
            <div v-show="authButtonShow">
              <ValidationProvider name="인증번호" rules="required|max:4" v-slot="{ errors }" vid="authKey" ref="authNum">
                <input
                  type="number"
                  id="phone_3"
                  class="ipt addTxt"
                  autocomplete="off"
                  title="인증번호 입력"
                  placeholder=""
                  value=""
                  v-model="authKey"
                />
                <span class="txt">
                  유효시간
                  <strong class="pointC1">{{ authTime | convertTimeToMS }}</strong>
                </span>
                <p class="fieldMsg error" id="idMsg" v-if="errors[0]">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>

          <!-- btnArea (s) -->
          <div class="btnArea mt20">
            <button type="button" class="btn_p" @click="checkUser">확인</button>
          </div>
          <!-- btnArea (e) -->
        </section>
      </div>

      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import MessagePop from '@/components/popup/MessagePop';
import { INPUT_INFO_CHECK, AUTH_TIMEOUT } from '@/store/message.type';

export default {
  name: 'authAccount',
  components: {
    MessagePop,
  },
  mounted() {
    this.userInfo = JwtService.getUserInfo();
    this.cellNum = this.phoneFomatter(this.userInfo.mobile);
    this.userId = this.userInfo.userId;
    console.log(this.userInfo);
  },
  data: function() {
    return {
      headerTitle: '회원정보수정',
      authButtonTitle: '인증번호요청',
      password: '',
      userInfo: null,
      userId: '',
      tranId: '',
      cellNum: '',
      authTime: 180,
      authKey: null,
      authButtonShow: false,
      messagePop: false,
      msg: null,
    };
  },
  watch: {
    authTime() {
      if (this.authTime == 0) {
        this.authButtonTitle = '인증번호요청'; // 버튼 타이틀 초기값으로 변경
        clearInterval(this.countDown); // 카운트다운 초기화
        this.authKey = null; // 인증번호 입력란 초기화
        // this.authTime = 180;
        this.authTime = 180; // 인증번호 시간 초기화
        this.msg = AUTH_TIMEOUT; // API 서버에서도 리턴해주지만 클라이언트 쪽에서 처리하기 위해 메세지 추가
        this.messagePop = true;
      }
    },
  },
  methods: {
    nextStep: function() {
      this.$router.push({ name: 'changeUserInfo' });
    },
    checkUser: function() {
      // 인증번호 일치여부 체크
      ApiService.service('POST', 'common/sms/auth/check', {
        request: {
          smsType: 'SPSM0007',
          tranId: this.tranId,
          userId: this.userId,
          cellNum: this.userInfo.mobile,
          birth: this.userInfo.birth,
          userName: this.userInfo.userName,
          authKey: this.authKey,
        },
        serviceType: 'app',
      })
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed) {
            this.$router.replace({ name: 'changeUserInfo' });
          } else {
            this.msg = data.error;
            this.errorCode = data.errorCode;
            this.messagePop = true;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    sendAuthNumber() {
      ApiService.service('POST', 'common/sms/auth', {
        request: {
          cellNum: this.userInfo.mobile,
          sendType: 'SPSM0007',
          userId: this.userId,
        },
        serviceType: 'app',
      })
        .then(({ data }) => {
          console.log(data);

          //인증번호 요청후 버튼 show
          this.authButtonShow = true;

          // TODO 모바일 테스트
          this.authKey = data.result.authKey;
          this.tranId = data.result.transactionId;
          this.authButtonTitle = '재요청';

          clearInterval(this.countDown);
          this.authTime = 180;
          this.countDown = setInterval(() => {
            this.authTime--;
          }, 1000);
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    close() {
      this.messagePop = false;
    },
    phoneFomatter(num) {
      var formatNum = '';
      if (num.length == 11) {
        formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
      } else if (num.length == 8) {
        formatNum = num.replace(/(\d{4})(\d{4})/, '$1-$2');
      } else {
        if (num.indexOf('02') == 0) {
          formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
        } else {
          formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        }
      }
      return formatNum;
    },
  },
};
</script>
